@if (shouldDisplayMap) {
  <div class="map-container">
    @if (isLoading) {
      <ion-skeleton-text [animated]="true" class="map-skeleton"></ion-skeleton-text>
    }
    <pinch-zoom #pinchZoom [disabled]="disablePinchZoom" [ngClass]="{ 'map-loading': isLoading }">
      <ion-img (ionImgDidLoad)="onImageDidLoad()" [src]="mapImageUrl" class="map"></ion-img>
    </pinch-zoom>
  </div>
} @else {
  <div class="full-width placeholder">
    <ion-icon name="location-outline"></ion-icon>
  </div>
}
